/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Appointment from './Appointment/index'
import AppointmentOptions from './AppointmentOptions/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContent from 'DesignSystem/Popover/PopoverContent/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/NextAppointment/Content/Content/Content",
  ignoreClickOutsideIf
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'color.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Next"
 size="small"
 color={dtColorNeutral600}
/>
<Popover
  viewPath={`${viewPath}/Popover`}
 offsetMainAxis={-6}
 placement="bottom-end"
 ignoreClickOutsideIf={ignoreClickOutsideIf}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<Appointment
{...childProps}
  viewPath={`${viewPath}/Appointment`}
/>
)}
</PopoverTrigger>
<PopoverContent
{...childProps}
  viewPath={`${viewPath}/PopoverContent`}
 width={160}
>
{childProps => (
<AppointmentOptions
{...childProps}
  viewPath={`${viewPath}/AppointmentOptions`}
/>
)}
</PopoverContent>
</React.Fragment>
)}
</Popover>
</div>
{children}
</React.Fragment>)
}